import { SET_ACCESS_TOKEN, RESTE_ALL_AUTH_DATA, SET_PROFILE_AUTH, SET_AUTH_LOADING } from "../../action/auth/type"

const initalState = {

    // accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY5OWMxZGU1ZTI0NTRmNmNmYTY5OGVlNiIsImlhdCI6MTc3NzIzMzE1MiwiZXhwIjoxNzc3MjM0MDUyfQ.tsfzAQ2hyhBkYqS_7_mNUM4J8-ZuI0NwMCpaEmc17m0',
    accessToken: null,
    profile: {},
}

const authReducer = (state = initalState, action) => {

    switch(action.type){

        case SET_ACCESS_TOKEN :
            return {
                ...state,
                accessToken: action.payload,
            }

        case SET_PROFILE_AUTH :
            return {
                ...state,
                profile: action.payload,
            }

        case RESTE_ALL_AUTH_DATA :
            return {
                ...state,
                ...initalState
            }

        default : 
            return state

    }

}

export default authReducer